import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useSession } from "@/state/SessionProvider";

export function useUserRole() {
  const { user } = useSession();

  return useQuery({
    queryKey: ["user-role", user?.id],
    enabled: !!user,
    queryFn: async () => {
      if (!user) return { isAdmin: false, isModerator: false, isUser: true };

      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user.id);

      if (error) throw error;

      const roles = data?.map(r => r.role) || [];
      
      return {
        isAdmin: roles.includes("admin"),
        isModerator: roles.includes("moderator"),
        isUser: roles.includes("user") || roles.length === 0,
      };
    },
  });
}
